let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1oxe3")).then(() => parcelRequire('2fcAX'));